import { incYenOf, incOf } from '../lib/pricing';
export const detailsHero = {
  title: 'コース別料金詳細',
  titleEn: 'TUITION DETAILS',
  lead: '各コースの受講料に含まれる内容を、詳しくご案内します。',
};

export const courseDetails = [
  {
    id: 'essential',
    name: 'エッセンシャルコース',
    nameEn: 'ESSENTIAL COURSE',
    price: incOf('ac-essential'),
    duration: '1ヶ月',
    days: '8日間',
    hours: '48時間',
    qualification: '認定アソシエイトバトラー',
    qualificationEn: 'Certified Associate Butler',
    lead: '執事としての基礎を固める入門コース。必要な技能と知識を、体系的かつ無理なく習得できる設計です。',
    categories: [
      {
        label: '授業',
        items: [
          '対面授業 48時間（8日間・土日開催）',
          '講義と実技を組み合わせたカリキュラム',
          '少人数制（1クラス定員制）',
        ],
      },
      {
        label: '教材',
        items: [
          '協会監修教科書セット 全5冊（E1〜E5）',
          '実習用ハンドアウト一式',
        ],
      },
      {
        label: '実習',
        items: [
          'アカデミー内スタジオでのロールプレイング実習',
          'テーブルセッティング・ティーサービス・衣類ケア実技',
        ],
      },
      {
        label: '特典',
        items: [
          'エプロン（実習着）',
          '白手袋（高品質・標準支給）',
        ],
      },
      {
        label: '試験',
        items: [
          '修了実技試験',
          '合格者に認定アソシエイトバトラー資格と認定ピンバッジを授与',
        ],
      },
    ],
  },
  {
    id: 'advanced',
    name: 'アドバンスコース',
    nameEn: 'ADVANCED COURSE',
    price: incOf('ac-advanced'),
    duration: '2ヶ月',
    days: '12日間',
    hours: '72時間',
    qualification: '認定プロフェッショナルバトラー',
    qualificationEn: 'Certified Professional Butler',
    lead: '基礎を土台に、より高度なサービス技能とホスピタリティマネジメントを習得する中級コースです。',
    categories: [
      {
        label: '授業',
        items: [
          '対面授業 72時間（12日間・土日開催）',
          '講義と実技を組み合わせたカリキュラム',
          '少人数制（1クラス定員制）',
        ],
      },
      {
        label: '教材',
        items: [
          '協会監修教科書セット 計10冊（E1〜E5・A1〜A5）',
          'エッセンシャルのE群5冊に加え、家政管理・秘書業務・テーブルマナー・イベント企画・ライフスタイル管理のA群5冊',
          '実習用ハンドアウト一式',
        ],
      },
      {
        label: '実習',
        items: [
          'アカデミー内スタジオでのロールプレイング実習',
          '本物のサービスをゲストとして体験する特別実習（1回）',
          'ワイン・ティーサービス技法',
          'イベント設営・運営演習',
        ],
      },
      {
        label: '特典',
        items: [
          'ワインオープナーセット',
          '白手袋（高品質・標準支給）',
          '修了生向け求人情報（準備中）',
        ],
      },
      {
        label: '試験',
        items: [
          '修了実技試験',
          '合格者に認定プロフェッショナルバトラー資格と認定ピンバッジを授与',
        ],
      },
    ],
  },
  {
    id: 'master',
    name: 'マスターコース',
    nameEn: 'MASTER COURSE',
    price: incOf('ac-master'),
    duration: '3ヶ月',
    days: '16日間',
    hours: '96時間',
    qualification: '認定マスターバトラー',
    qualificationEn: 'Certified Master Butler',
    lead: '執事としての総合的な専門性とマネジメント能力を極める最上級コース。プロフェッショナルに必要な全領域を網羅します。',
    categories: [
      {
        label: '授業',
        items: [
          '対面授業 96時間（16日間・土日開催）',
          '講義と実技を組み合わせたカリキュラム',
          '少人数制（1クラス定員制）',
        ],
      },
      {
        label: '教材',
        items: [
          '協会監修教科書セット 全15冊（E1〜E5・A1〜A5・M1〜M5）',
          'E群・A群に加え、国際プロトコル・危機管理・VVIPサービスなどM群5冊を含む全巻',
          '実習用ハンドアウト一式',
        ],
      },
      {
        label: '実習',
        items: [
          'アカデミー内スタジオでのロールプレイング実習',
          '本物のサービスをゲストとして体験する特別実習（1回）',
          'マスタークラス 2回（ゲスト講師招聘）',
          '個別コーチング 2回（指導講師によるマンツーマン指導）',
          '総合実技演習（アカデミー内で学んだ全技能を統合した実演）',
        ],
      },
      {
        label: '特典',
        items: [
          'オーダーメイドベスト（受講生別採寸・仕立て）',
          '高級懐中時計',
          '白手袋（高品質・標準支給）',
          '修了生向け求人情報（準備中）',
        ],
      },
      {
        label: '試験',
        items: [
          '修了実技試験',
          '合格者に認定マスターバトラー資格と認定ピンバッジを授与',
        ],
      },
    ],
  },
];

export const transferDiscountDetails = {
  discounts: [
    {
      from: 'エッセンシャルコース修了',
      to: 'アドバンスコース進学',
      amount: '80,000',
    },
    {
      from: 'アドバンスコース修了',
      to: 'マスターコース進学',
      amount: '180,000',
    },
  ],
};

export const paymentFlow = [
  {
    step: '01',
    title: 'お申込み',
    description: '所定の申込フォームより、希望コースをお申込みください。定員になり次第、締切となります。',
    icon: 'ri-edit-line',
  },
  {
    step: '02',
    title: '受講契約のご案内',
    description: 'お申込み内容を確認のうえ、受講契約に関するご案内をお送りします。',
    icon: 'ri-file-text-line',
  },
  {
    step: '03',
    title: '受講料のお振込み',
    description: '銀行振込（一括払い）にて、開校日の14日前までにお振込みください。分割払い・クレジットカードはご利用いただけません。',
    icon: 'ri-bank-line',
  },
  {
    step: '04',
    title: '受講確定',
    description: 'ご入金を確認次第、受講確定となります。開校日や持ち物など、事前にご案内いたします。',
    icon: 'ri-check-double-line',
  },
];

export const detailsFaqs = [
  {
    question: '料金に特別実習（サービス体験）も含まれますか?',
    answer: '体験にかかる費用の詳細はお申込み時にご案内します（体験先までの交通費を除く）。',
  },
  {
    question: '編入優遇はどう適用されますか?',
    answer: 'エッセンシャル修了者はアドバンスで80,000円、アドバンス修了者はマスターで180,000円が受講料から減額されます。お申込み時に申告してください。',
  },
  {
    question: '追加費用はかかりますか?',
    answer: '教材費・実習費・特典・試験料は受講料に含まれます。出張を伴う実習の交通費など一部実費を除き、追加のご負担は原則ありません。',
  },
];

export const detailsRelatedPages = [
  {
    title: '料金概要',
    description: '受講料と含まれるもの',
    href: '/pricing',
  },
  {
    title: '受講特典',
    description: '実務で使える受講特典',
    href: '/benefits',
  },
  {
    title: '修了証・認定資格について',
    description: '修了で得られる協会認定資格',
    href: '/certificate',
  },
  {
    title: 'コース一覧・比較',
    description: '3コースの違いを一覧で確認',
    href: '/courses',
  },
];